import { upperFirst } from "lodash";

export default function unCamelCase(str) {
  return (
    str
      // insert a space between lower & upper
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      // space before last upper in a sequence followed by lower
      .replace(/\b([A-Z]+)([A-Z])([a-z])/, "$1 $2$3")
      // uppercase the first character
      .replace(/^./, (finalStr) => {
        return finalStr.toUpperCase();
      })
  );
}

export function useUpperFirst(str) {
  return upperFirst(str);
}
